import actionCreator from '../../utils/actionCreator';
import IntlTypes from './constants';

export const changeLocale = params => actionCreator(IntlTypes.CHANGE_LOCALE_START, params);
export const setInitialLocale = params => actionCreator(IntlTypes.SET_INITIAL_LOCALE, params);
